export default __webpack_public_path__ + "static/media/icon-arrow.6e451a03.svg";